let isLoading = false;

const loadItems = (button) => {
  if (isLoading) return;
  isLoading = true;

  const totalPages = parseInt($('[data-total-pages]').val());
  let currentPage = parseInt($('[data-current-page]').val());
  const nextPage = currentPage + 1;

  const currentUrl = $('[data-next-url]').val();
  const nextUrl = currentUrl.replace(/page=\d+/, 'page=' + nextPage);

  button.setAttribute('disabled', '');
  button.classList.add('loading');
  $.ajax({
    url: nextUrl,
    type: 'GET',
    dataType: 'html',
    success: function (responseHTML) {
      const $newContent = $(responseHTML).find('.load-more-grid').html();
      $('.load-more-grid').append($newContent);
      colorSwatches();

      // Extract the new cursor from the response
      const $responseDOM = $(responseHTML);
      const newNextUrl = $responseDOM.find('[data-next-url]').val();

      // Use the next URL from the response rather than constructing our own
      if (newNextUrl) {
        $('[data-next-url]').val(newNextUrl);
      } else {
        // Fall back to manual construction if needed
        $('[data-next-url]').val(nextUrl);
      }

      $('[data-current-page]').val(nextPage);

      // Remove any duplicate inputs
      if ($('[data-next-url]').length > 1) {
        $('[data-next-url]:gt(0)').remove();
      }
      if ($('[data-current-page]').length > 1) {
        $('[data-current-page]:gt(0)').remove();
      }

      if (nextPage === totalPages) {
        button.remove();
      }
    },
    complete: function () {
      button.removeAttribute('disabled');
      button.classList.remove('loading');
      isLoading = false;
    },
  });
};

const checkVisibility = () => {
  const spinnerList = document.querySelectorAll('.js-infinite-scroll');
  spinnerList.forEach((spinner) => {
    const sectionObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          loadItems(spinner);
        }
      });
    });

    sectionObserver.observe(spinner);
  });
};

function loadMore() {
  document.querySelectorAll('.js-load-more').forEach((button) => {
    button.onclick = () => {
      loadItems(button);
    };
  });

  checkVisibility();
}

(function () {
  loadMore();
})();
